import { FormControl, FormControlLabel, FormHelperText, Checkbox as MuiCheckbox, CheckboxProps as MuiCheckboxProps } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import React, { FC } from 'react';

interface ICheckboxProps extends Omit<MuiCheckboxProps, 'name' | 'defaultValue'> {
  label: string;
  name: string;
  control: Control<any>;
  defaultValue?: boolean;
  onChangeCallback?: (value: boolean) => void;
  error?: boolean;
  helperText?: string;
}

const Checkbox: FC<ICheckboxProps> = ({ 
  onChangeCallback, 
  label, 
  name, 
  control, 
  defaultValue, 
  error = false,
  helperText,
  ...rest 
}) => {
  return (
    <FormControl error={error} component="fieldset">
      <Controller
        name={name}
        control={control}
        render={({ field }) => {
          console.log(`Checkbox ${name} - valor atual:`, field.value, '-> Boolean:', Boolean(field.value));
          return (
            <FormControlLabel
              control={
                <MuiCheckbox
                  {...field}
                  checked={Boolean(field.value)}
                  inputRef={field.ref}
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    console.log(`Checkbox ${name} - mudando para:`, isChecked);
                    field.onChange(isChecked); // Atualiza o valor no form
                    if (onChangeCallback) {
                      onChangeCallback(isChecked); // Dispara o callback
                    }
                  }}
                  {...rest}
                />
              }
              label={label}
            />
          );
        }}
      />
      {helperText && (
        <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export { Checkbox };
